export default __webpack_public_path__ + "static/stage-1_2-cafd960a4dcb2a950b6faf76a43e1637.jpg";